module.exports = __webpack_public_path__ + "img/audio-link.51945975.svg";